var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":_vm.props.size,"height":_vm.props.size}},[_c('use',{attrs:{"xlink:href":("#icon-" + (_vm.props.name))}})])}
var staticRenderFns = []

export { render, staticRenderFns }